export default __webpack_public_path__ + "static/media/slider2.bf33bcc1.png";